import * as yup from 'yup';

import { validateDate, validateEmail } from 'app/utils/validations';

export const addPersonFormSchema = yup.object().shape({
  firstName: yup
    .string()
    .required('First name is mandatory')
    .min(2, 'First name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "First name should only contain letters, spaces, and symbols (.-')"
    ),
  lastName: yup
    .string()
    .required('Last name is mandatory')
    .min(2, 'Last name should contain at least 2 letters')
    .matches(
      /^[a-zA-ZÀ-ÿ\s'.-]+$/,
      "Last name should only contain letters, spaces, and symbols (.-')"
    ),
  email: yup
    .string()
    .required('Company email is mandatory')
    .test('Invalid email', 'Enter a valid email', (value) => validateEmail(value)),
  startDate: yup
    .string()
    .test('Invalid date', 'Enter a valid date', (value) => !value || validateDate(value)),
  leaveDate: yup
    .string()
    .test('Invalid date', 'Enter a valid date', (value) => !value || validateDate(value)),
});

export default addPersonFormSchema;
